import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

interface ICreateApiCall {
    id: string;
    title: string;
    ctime: number;
    photos_count: number;
}

export class CreateAlbumAPICall extends APICallV4<ICreateApiCall> {
    _method = 'album/create';
    _type: Method = 'post';
}
